export default __webpack_public_path__ + "static/media/Letter M.471d51e6.mov";